import React from 'react';
import { Settings } from '@pascal/pascal-core/table-line';
import { useTranslation } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { SettingRowColumn } from '../../components/settingRowColumn';
import { SettingRow } from '../../components/settingRow';
import { CARD_BACKSIDE_TYPES, CARD_VIEW_TYPES } from '../../enums/cardTypes';
import { cardsStore } from '../../store/cardsStore';

export const SettingsContainer = observer(() => {
  const {
    selectedCardBackSideType,
    selectedCardType,
    setSelectedCardBackSideType,
    setSelectedCardType,
  } = cardsStore;
  const t = useTranslation();
  return (
    <>
      <Settings />
      <SettingRow>
        <SettingRowColumn position='left'>
          <SettingRowColumn.Span text={t('CARDS')} />
        </SettingRowColumn>
        <SettingRowColumn position='right'>
          <SettingRowColumn.Cards>
            <SettingRowColumn.Card
              imgType={CARD_VIEW_TYPES.calodeOne}
              cardType='card-As'
              isActive={selectedCardType === CARD_VIEW_TYPES.calodeOne}
              onClick={() => setSelectedCardType(CARD_VIEW_TYPES.calodeOne)}
            />
            <SettingRowColumn.Card
              imgType={CARD_VIEW_TYPES.calodeTwo}
              cardType='card-As'
              isActive={selectedCardType === CARD_VIEW_TYPES.calodeTwo}
              onClick={() => setSelectedCardType(CARD_VIEW_TYPES.calodeTwo)}
            />
          </SettingRowColumn.Cards>
        </SettingRowColumn>
      </SettingRow>
      <SettingRow>
        <SettingRowColumn position='left'>
          <SettingRowColumn.Span text={t('CARDS_BACKS')} />
        </SettingRowColumn>
        <SettingRowColumn position='right'>
          <SettingRowColumn.Cards>
            <SettingRowColumn.Card
              imgType={CARD_BACKSIDE_TYPES.backsideOne}
              isActive={selectedCardBackSideType === CARD_BACKSIDE_TYPES.backsideOne}
              onClick={() => setSelectedCardBackSideType(CARD_BACKSIDE_TYPES.backsideOne)}
            />
            <SettingRowColumn.Card
              imgType={CARD_BACKSIDE_TYPES.backsideTwo}
              isActive={selectedCardBackSideType === CARD_BACKSIDE_TYPES.backsideTwo}
              onClick={() => setSelectedCardBackSideType(CARD_BACKSIDE_TYPES.backsideTwo)}
            />
            <SettingRowColumn.Card
              imgType={CARD_BACKSIDE_TYPES.backsideThree}
              isActive={selectedCardBackSideType === CARD_BACKSIDE_TYPES.backsideThree}
              onClick={() => setSelectedCardBackSideType(CARD_BACKSIDE_TYPES.backsideThree)}
            />
            <SettingRowColumn.Card
              imgType={CARD_BACKSIDE_TYPES.backsideFour}
              isActive={selectedCardBackSideType === CARD_BACKSIDE_TYPES.backsideFour}
              onClick={() => setSelectedCardBackSideType(CARD_BACKSIDE_TYPES.backsideFour)}
            />
          </SettingRowColumn.Cards>
        </SettingRowColumn>
      </SettingRow>
    </>
  );
});
